import $ from '@nuskin/nuskinjquery';
import {utilModule} from '../module.js';
import {UrlService} from '@nuskin/ns-util';
import angular from 'angular';

utilModule.directive('nsServerValidate', [function() {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr, ctrl) {
            ele.on('blur', function () {
                let testStr = ele.val();
                if (testStr && testStr != "") {
                    scope.$apply(function () {
                        let validationRuleStr = attr.nsServerValidate;
                        if ((validationRuleStr != null) && (validationRuleStr.length > 0)) {
                            // if there are more than one validationRules separated by a comma
                            let validationRules = validationRuleStr.split(",");
                            let url = UrlService.getSiteUrl + '/' + 'apps/global/services/validationRule';

                            angular.forEach(validationRules, function (aRule) {
                                $.ajax({
                                    url: url,
                                    data: {rule: aRule.trim(), data: encodeURIComponent(testStr)}
                                }).done(function (result) {
                                    ctrl.$setValidity(aRule, result.valid);
                                });
                            });
                        }
                    });
                }
            });
        }
    };
}]);
